
import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { UserService } from 'src/app/service/user.service';
import Swal from 'sweetalert2';
import {OwlOptions} from "ngx-owl-carousel-o";

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent implements OnInit {

  currentRate: any;
  reviewForm: any;
  review: any;

  constructor(private scrollToService: ScrollToService,private formBuilder: FormBuilder,private userService:UserService,private route :Router) {
    this.reviewForm = this.formBuilder.group({
      email: ['',Validators.required],
      name: ['', Validators.required],
      review: ['', Validators.required],
    });
  }
  customOptions2: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      900: {
        items: 1
      }
    },
    nav: false
  };
  config2: any;


  ngOnInit(): void {
    this.triggerScrollTo();
    this.getAllReviews();
  }

  reveiw(){
    let req ={
      clientEmail:  this.reviewForm.controls.email.value,
      clientName:  this.reviewForm.controls.name.value,
      review:  this.reviewForm.controls.review.value,
    }
    console.log('rate'+ this.currentRate);
    this.userService.addReview(req).subscribe(
        res => {
          if (res.responseCode == 200) {
            Swal.fire(
                'Review Success!',
                'session booked successfully',
                'success'
            )
            this.route.navigate(['/']);
          } else {
            Swal.fire(
                'Review Faild !',
                'somthing went wrong please try again',
                'error'
            )
          }
        }
    )
  }

  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }


  getAllReviews(){
    this.userService.getallReview().subscribe(
        res=>{
          this.review = res.data;
        }
    )
  }
}
